import { Link, useNavigate } from "react-router-dom";
import { Search, ShoppingCart, User, LogOut, Heart, Menu } from "lucide-react";
import { useState } from "react";
import { useShop } from "../context/ShopContext";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { cartCount, favorites } = useShop();
  const { user, logout, isAdmin, isCorporate } = useAuth();
  const [open, setOpen] = useState(false);
  const [term, setTerm] = useState("");
  const navigate = useNavigate();

  const submitSearch = (e) => {
    e.preventDefault();
    const q = term.trim();
    navigate(q ? `/products?q=${encodeURIComponent(q)}` : "/products");
    setTerm("");
    setOpen(false);
  };

  const accountLabel = user
    ? `${user.fullName} · ${
        user.accountType === "corporate"
          ? "Kurumsal"
          : user.accountType === "admin"
            ? "Admin"
            : "Bireysel"
      }`
    : "Hesap";

  const goSelect = (e) => {
    const value = e.target.value;
    if (!value) return;
    if (value === "logout") logout();
    else navigate(value);
    e.target.value = "";
    setOpen(false);
  };

  const handleLogout = () => {
    logout();
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur border-b border-stone-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between gap-4">
        <Link
          to="/"
          className="flex shrink-0 items-center overflow-visible"
          onClick={() => setOpen(false)}
          aria-label="Sevinç Outdoor ana sayfa"
        >
          <img
            src="/sevinc-logo.png"
            alt="Sevinç Outdoor"
            className="h-20 sm:h-24 lg:h-28 w-auto object-contain scale-125 origin-left"
          />
        </Link>

        <form
          onSubmit={submitSearch}
          className="hidden lg:flex items-center gap-3 bg-white border border-stone-200 px-4 h-11 rounded-full flex-1 max-w-lg shadow-sm"
        >
          <Search size={18} className="text-stone-500" />
          <input
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            placeholder="Ürün ara..."
            className="bg-transparent outline-none w-full text-sm"
          />
        </form>

        <div className="flex items-center gap-4 sm:gap-5">
          {isCorporate && (
            <span className="hidden xl:inline text-xs bg-stone-100 text-stone-900 px-3 py-1 rounded-full">
              Kurumsal Fiyat
            </span>
          )}

          {!isAdmin && (
            <>
              <Link to="/favorites" className="relative" aria-label="Favoriler">
                <Heart size={22} />
                {favorites.length > 0 && (
                  <span className="absolute -top-2 -right-3 bg-rose-500 text-white text-xs w-5 h-5 grid place-items-center rounded-full">
                    {favorites.length}
                  </span>
                )}
              </Link>

              <Link to="/cart" className="relative" aria-label="Sepet">
                <ShoppingCart size={22} />
                {cartCount > 0 && (
                  <span className="absolute -top-2 -right-3 bg-stone-800 text-white text-xs w-5 h-5 grid place-items-center rounded-full">
                    {cartCount}
                  </span>
                )}
              </Link>
            </>
          )}

          {user ? (
            <select
              onChange={goSelect}
              defaultValue=""
              className="hidden md:block h-10 max-w-[230px] border border-stone-200 bg-white rounded-full px-4 text-sm outline-none"
            >
              <option value="" disabled>
                {accountLabel}
              </option>

              {isAdmin ? (
                <>
                  <option value="/admin">Ürün Ekle / Yönet</option>
                  <option value="/orders">Gelen Siparişler</option>
                </>
              ) : (
                <>
                  <option value="/orders">Siparişlerim</option>
                  <option value="/cart">Sepetim</option>
                </>
              )}

              <option value="logout">Çıkış Yap</option>
            </select>
          ) : (
            <Link
              to="/login"
              className="hidden md:flex items-center gap-2 text-sm font-medium"
            >
              <User size={18} />
              Giriş
            </Link>
          )}

          <button
            type="button"
            onClick={() => setOpen(!open)}
            className="md:hidden"
            aria-label="Menüyü aç/kapat"
          >
            <Menu size={24} />
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-2 lg:hidden">
        <form
          onSubmit={submitSearch}
          className="flex items-center gap-3 bg-white border border-stone-200 px-4 h-11 rounded-full"
        >
          <Search size={18} />
          <input
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            placeholder="Ürün ara..."
            className="bg-transparent outline-none w-full text-sm"
          />
        </form>
      </div>

      {open && (
        <div className="md:hidden px-5 pb-5 flex flex-col gap-3 bg-cream border-t border-stone-100">
          {user ? (
            <>
              <p className="text-sm bg-white p-3 rounded-xl border border-stone-200">
                {accountLabel}
              </p>

              {isAdmin ? (
                <>
                  <Link to="/admin" onClick={() => setOpen(false)}>
                    Ürün Ekle / Yönet
                  </Link>
                  <Link to="/orders" onClick={() => setOpen(false)}>
                    Gelen Siparişler
                  </Link>
                </>
              ) : (
                <>
                  <Link to="/orders" onClick={() => setOpen(false)}>
                    Siparişlerim
                  </Link>
                  <Link to="/favorites" onClick={() => setOpen(false)}>
                    Favorilerim
                  </Link>
                  <Link to="/cart" onClick={() => setOpen(false)}>
                    Sepetim
                  </Link>
                </>
              )}

              <button
                type="button"
                onClick={handleLogout}
                className="text-left text-red-600 flex items-center gap-2"
              >
                <LogOut size={17} />
                Çıkış
              </button>
            </>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)}>
              Giriş / Kayıt
            </Link>
          )}
        </div>
      )}
    </header>
  );
}
